import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
const confirm = Modal.confirm;

import { graphql, compose, withApollo } from 'react-apollo';

import SelectorModelo from '../formularios/SelectorModelo';
import FormInformacionSumaria from '../formularios/FormInformacionSumaria';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import Loading from '../../common/Loading';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertInformacionSumaria from '../../../graphql/mutations/tramites/insertInformacionSumaria.graphql';
import crearInformacionSumaria from '../../../graphql/mutations/tramites/crearInformacionSumaria.graphql';
import confirmarInformacionSumaria from '../../../graphql/mutations/tramites/confirmarInformacionSumaria.graphql';
import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';

import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { imprimir } from '../../common/funciones/imprimir';

import moment from 'moment';
import _ from 'lodash';
import { verPdf } from '../../common/funciones/verPdf';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertInformacionSumaria, {
    name: 'createInformacionSumaria',
  }),
  graphql(crearInformacionSumaria, {
    name: 'crearInformacionSumaria',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(confirmarInformacionSumaria, {
    name: 'confirmarInformacionSumaria',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(getUsuario)
)
class CrearInformacionSumaria extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      declarante: {},
      testigo1: {},
      testigo2: {},
      testimonio: '',
      ente_receptor: '',
      numero: '',
      step: 0,
      guardado: false,
      confirmado: false,
      loading: false,
      detalles: [],
      datosPosnet: {},
      extras: {},
    };

    this.guardarDatosDeclaracion = this.guardarDatosDeclaracion.bind(this);
    this.notaSeleccionada = this.notaSeleccionada.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);
    this.confirmarInformacionSumaria = this.confirmarInformacionSumaria.bind(
      this
    );

    this.finProcesoGeneracion = this.finProcesoGeneracion.bind(this);
    this.obtenerDatosGeneracion = this.obtenerDatosGeneracion.bind(this);
    this.onImprimir = this.onImprimir.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarDeclarante = persona => {
    this.setState(
      {
        declarante: {
          ...this.state.declarante,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarTestigo1 = persona => {
    this.setState(
      {
        testigo1: {
          ...this.state.testigo1,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarTestigo2 = persona => {
    this.setState(
      {
        testigo2: {
          ...this.state.testigo2,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarDatosDeclaracion(datos, ventaSinStock) {
    // console.log(datos);

    this.setState(
      {
        ...this.state,
        testimonio: datos.testimonio,
        ente_receptor: datos.ente_receptor,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      function() {
        this.persistirDatos(ventaSinStock);
        // this.siguientePaso();
      }
    );
  }

  notaSeleccionada(idNota) {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  }

  obtenerDatosGeneracion() {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (
      this.state.informacion_sumaria &&
      this.state.informacion_sumaria.venta
    ) {
      let venta = this.state.informacion_sumaria.venta;
      textoOperacion = `Por este trámite se abono la suma de $${
        venta.importe
      } mediante el uso de ${
        venta.tipoPago
      }, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }

    let datos = {
      ...this.state.declarante,
      fecha_nacimiento: this.state.declarante.fecha_nacimiento
        ? moment(this.state.declarante.fecha_nacimiento).toDate()
        : '',
      edad: this.state.declarante.fecha_nacimiento
        ? Math.floor(
            moment(new Date()).diff(
              moment(this.state.declarante.fecha_nacimiento),
              'years',
              true
            )
          )
        : '',
      direccion_otro:
        this.state.declarante.direccion_otro &&
        this.state.declarante.direccion_otro.length > 0
          ? this.state.declarante.direccion_otro
          : ' ',
      testigo1: {
        ...this.state.testigo1,
        localidad:
          this.state.testigo1.localidad && this.state.testigo1.localidad.nombre
            ? this.state.testigo1.localidad.nombre
            : this.state.testigo1.localidad,
        fecha_nacimiento: this.state.testigo1.fecha_nacimiento
          ? moment(this.state.testigo1.fecha_nacimiento).toDate()
          : '',
        edad: this.state.testigo1.fecha_nacimiento
          ? Math.floor(
              moment(new Date()).diff(
                moment(this.state.testigo1.fecha_nacimiento),
                'years',
                true
              )
            )
          : '',
        direccion_otro:
          this.state.testigo1.direccion_otro &&
          this.state.testigo1.direccion_otro.length > 0
            ? this.state.testigo1.direccion_otro
            : ' ',
      },
      testigo2: {
        ...this.state.testigo2,
        localidad:
          this.state.testigo2.localidad && this.state.testigo2.localidad.nombre
            ? this.state.testigo2.localidad.nombre
            : this.state.testigo2.localidad,
        fecha_nacimiento: this.state.testigo2.fecha_nacimiento
          ? moment(this.state.testigo2.fecha_nacimiento).toDate()
          : '',
        edad: this.state.testigo2.fecha_nacimiento
          ? Math.floor(
              moment(new Date()).diff(
                moment(this.state.testigo2.fecha_nacimiento),
                'years',
                true
              )
            )
          : '',
        direccion_otro:
          this.state.testigo2.direccion_otro &&
          this.state.testigo2.direccion_otro.length > 0
            ? this.state.testigo2.direccion_otro
            : ' ',
      },
      testimonio: this.state.testimonio,
      ente_receptor: this.state.ente_receptor,
      numero: this.state.numero,
      organismo: this.props.data.getUsuario.organismo,
      textoOperacion: textoOperacion,
    };

    // console.log("los datos quedan de la siguiente manera: ");
    // console.log(datos);

    return datos;
  }

  finProcesoGeneracion(textoGenerado) {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una declaracion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        // console.log("Entre al sync");
        this.siguientePaso();
      }
    );
  }

  async onImprimir(htmlFinal) {
    const rta = await this.confirmarInformacionSumaria();

    if (rta || this.state.confirmado) {
      //TODO: IMPRIMIR
      // console.log("La respuesta es.....");
      // console.log(rta);
      imprimir(htmlFinal);
    }
  }

  async confirmarInformacionSumaria() {
    const { confirmado } = this.state;

    if (!confirmado) {
      try {
        const rta = await this.props.confirmarInformacionSumaria({
          variables: {
            _id: this.state.informacion_sumaria._id,
            idModeloNota: this.state.nota.idModeloNota,
            numero: this.state.numero,
          },
        });
        if (rta) {
          notification.success({
            message: 'Informacion Sumaria Confirmada!',
            description: 'Se ha confirmado con exito la Informacion Sumaria',
          });

          this.setState({
            ...this.state,
            confirmado: true,
          });

          return rta;
        }
      } catch (err) {
        console.log('excepcion al confirmar la informacion sumaria');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la informacion sumaria',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      }
    }
  }

  persistirDatos(ventaSinStock) {
    //Antes que nada, debemos verificar si ya fue guardado en la base de datos
    //Esta situacion pasaria cuando el usuario ya haya tocado el boton de imprimir antes
    //Y por alguna razon, necesita volver a imprimir (pero los datos ya fueron guardados)

    if (this.state.guardado) {
      notification.warning({
        message:
          'Su I.S ya fue guardada, por lo que debe empezar desde 0 nuevamente.',
      });
      return;
    }

    //Luego, lo primero que hacemos es, verificamos si la persona tiene id, si es asi
    // es porque vino desde el servidor, porque ya existia.
    //Entonces, no debemos crearlo.

    if (this.state.declarante._id) {
      //Si ya existia la persona, creamos solo la declaracion.
      // console.log("Caso de que ya existia la persona");

      if (ventaSinStock) {
        this.crearInformacionSumariaConVenta(this.state.declarante._id);
      } else {
        this.crearVenta(this.state.declarante._id);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  crearInformacionSumariaConVenta = idPersona => {
    let informacion_sumaria;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = [];

    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;

    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket)
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };
    }
    //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
    informacion_sumaria = {
      fecha_creacion: new Date(),
      testimonio: this.state.testimonio,
      ente_receptor: this.state.ente_receptor,
      idDeclarante: this.state.declarante._id,
      idTestigo1: this.state.testigo1._id,
      idTestigo2: this.state.testigo2._id,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      idCreador: this.props.data.getUsuario._id,
    };

    this.props
      .crearInformacionSumaria({
        variables: { informacion_sumaria: informacion_sumaria, venta: venta },
      })
      .then(respuesta => {
        notification.success({
          message: 'Venta registrada',
          description: 'La venta se registro de forma exitosa',
        });

        notification.success({
          message: 'Nueva Informacion Sumaria',
          description: 'Se ha registrado con exito la informacion sumaria',
        });

        if (
          descargarRecibo &&
          respuesta.data.crearInformacionSumaria &&
          respuesta.data.crearInformacionSumaria.venta &&
          respuesta.data.crearInformacionSumaria.venta.recibo64
        ) {
          verPdf(
            respuesta.data.crearInformacionSumaria.venta.recibo64,
            `Recibo_Num_${respuesta.data.crearInformacionSumaria.venta.id}`
          );
        }

        this.setState(
          {
            ...this.state,
            informacion_sumaria: {
              ...this.state.informacion_sumaria,
              ...respuesta.data.crearInformacionSumaria,
            },
            guardado: true,
            loading: false,
          },
          () => {
            this.siguientePaso();
          }
        );
      })
      .catch(error => {
        console.log('Excepcion!!');
        console.log(error);
        this.setState({
          loading: false,
        });

        Modal.error({
          title: 'Error en la creacion de la informacion sumaria',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  // eslint-disable-next-line no-unused-vars
  crearVenta = idPersona => {
    let yo = this;

    let informacion_sumaria;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles } = this.state;

    let detallesFiltrados = [];

    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });

    if (existeVenta && detalles.length > 0) {
      confirm({
        title: 'Está seguro de que desea crear la IS CON VENTA?',
        content: 'No podrá hacer cambios sobre esta IS',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .insertDetalleVenta({
              variables: { detalleVenta: { detalle: detallesFiltrados } },
            })
            .then(res => {
              //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
              let detalles = res.data.insertDetalleVenta.detalle;

              let importe = _.sum(
                _.map(detalles, detalle => {
                  //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                  return detalle.cantidad * detalle.tipo_sello.valor;
                })
              );

              let venta = {
                importe: importe,
                fecha: moment().toDate(),
                idVendedor: this.props.data.getUsuario._id,
                idOrganismo: this.props.data.getUsuario.organismo._id,
                idDetalle_Venta: res.data.insertDetalleVenta._id,
                datosPosnet:
                  (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
                    ? {
                        codigoOperacion: datosPosnet.codigoOperacion,
                        numeroTicket: datosPosnet.numeroTicket,
                        cuenta: 'Tasas',
                      }
                    : null,
              };

              this.props
                .insertVenta({
                  variables: { venta: venta },
                })
                .then(res => {
                  informacion_sumaria = {
                    fecha_creacion: new Date(),
                    testimonio: this.state.testimonio,
                    ente_receptor: this.state.ente_receptor,
                    idDeclarante: this.state.declarante._id,
                    idTestigo1: this.state.testigo1._id,
                    idTestigo2: this.state.testigo2._id,
                    idOrganismo: this.props.data.getUsuario.organismo._id,
                    idCreador: this.props.data.getUsuario._id,
                    idVenta: res.data.insertVenta._id,
                    tipoVenta: venta.datosPosnet ? 'POSNET' : 'EFECTIVO',
                  };

                  this.props
                    .createInformacionSumaria({
                      variables: { informacion_sumaria: informacion_sumaria },
                    })
                    .then(respuesta => {
                      notification.success({
                        message: 'Venta registrada',
                        description: 'La venta se registro de forma exitosa',
                      });

                      notification.success({
                        message: 'Nueva Informacion Sumaria',
                        description:
                          'Se ha registrado con exito la informacion sumaria',
                      });

                      this.setState(
                        {
                          ...this.state,
                          informacion_sumaria: {
                            ...this.state.informacion_sumaria,
                            ...respuesta.data.insertInformacionSumaria,
                          },
                          guardado: true,
                          loading: false,
                        },
                        () => {
                          this.siguientePaso();
                        }
                      );
                    })
                    .catch(error => {
                      console.log('Excepcion!!');
                      console.log(error);
                      this.setState({
                        loading: false,
                      });

                      Modal.error({
                        title: 'Error en la creacion de la informacion sumaria',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                    });
                  return res;
                })
                .catch(err => {
                  console.log('Se ha producido un error');
                  console.log(err);
                  this.setState({
                    loading: false,
                  });
                  notification.error({
                    message: 'Error al registrar la venta',
                    description:
                      'Se ha producido un error al registrar la venta',
                  });

                  return err;
                });
            })
            .catch(err => {
              console.log(
                'Ocurrio un error a la hora de registrar el detalle de la venta'
              );
              console.log(err);
              this.setState({
                loading: false,
              });
              Modal.error({
                title:
                  'Error en la creacion de la venta, compruebe que exista stock por favor',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error('CANCELO LA CREACION DEL TRAMITE IS "CON VENTA" '),
            {
              estado: yo.state,
              existeVenta: existeVenta,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    } else {
      //caso donde solo debo crear la certificacion:

      informacion_sumaria = {
        fecha_creacion: new Date(),
        testimonio: this.state.testimonio,
        ente_receptor: this.state.ente_receptor,
        idDeclarante: this.state.declarante._id,
        idTestigo1: this.state.testigo1._id,
        idTestigo2: this.state.testigo2._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };

      confirm({
        title: 'Está seguro de que desea crear la IS SIN VENTA?',
        content: 'No podrá hacer cambios sobre esta IS',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .createInformacionSumaria({
              variables: { informacion_sumaria: informacion_sumaria },
            })
            .then(respuesta => {
              notification.success({
                message: 'Nueva Informacion Sumaria',
                description:
                  'Se ha registrado con exito la informacion sumaria',
              });

              this.setState(
                {
                  ...this.state,
                  informacion_sumaria: {
                    ...this.state.informacion_sumaria,
                    ...respuesta.data.insertInformacionSumaria,
                  },
                  guardado: true,
                  loading: false,
                },
                () => {
                  this.siguientePaso();
                }
              );
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);
              this.setState({
                loading: false,
              });
              Modal.error({
                title: 'Error en la creacion de la informacion sumaria',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error('CANCELO LA CREACION DEL TRAMITE IS "SIN VENTA" '),
            {
              estado: yo.state,
              existeVenta: existeVenta,
              is: informacion_sumaria,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    }
  };

  ModeloNotaElegido = idNota => {
    // console.log("La nota tiene el id de ....", idNota.modelo);
    // console.log("La nota tiene el id de ....", this.state.nota.idModeloNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        // console.log("Entre!");

        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log("Recibi de respuesta....");
            // console.log(respuesta);

            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            // console.log("ESTADO: ");
            // console.log(this.state);
            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
          });
      }
    );
  };

  onCancel() {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      testimonio: '',
      ente_receptor: '',
      step: 0,
      confirmado: false,
      guardado: false,
    });
    this.props.history.push('/');
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    const { Step } = Steps;
    let { step } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Informacion Sumaria</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Informacion Sumaria
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Declarante" />
            <Step title="Buscar Testigo 1" />
            <Step title="Buscar Testigo 2" />
            <Step title="Declaracion" />
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarDeclarante} />
            )}
            {step === 1 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarTestigo1} />
            )}
            {step === 2 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarTestigo2} />
            )}

            {step === 3 && (
              <FormInformacionSumaria
                organismo={this.props.data.getUsuario.organismo}
                onFinalizar={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosDeclaracion(datos, ventaSinStock)
                  )
                }
                onSubmit={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosDeclaracion(datos, ventaSinStock)
                  )
                }
                config={{ creacion: true }}
                datos={{
                  testimonio: this.state.testimonio,
                  ente_receptor: this.state.ente_receptor,
                }}
              />
            )}

            {step === 4 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.ModeloNotaElegido}
              />
            )}
            {step === 5 && (
              <Generador
                id={this.state.nota.idModeloNota}
                // datos={this.state.persona}
                datos={this.obtenerDatosGeneracion()}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 6 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={this.onImprimir}
                onGuardar={this.confirmarInformacionSumaria}
                onCancel={this.onCancel}
                accion="visualizar"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}
export default withApollo(CrearInformacionSumaria);
